module.exports = __webpack_public_path__ + "static/media/jianailiang.5bbdf649.png";